export default defineNuxtPlugin({
  name: 'pageTitle',
  parallel: true,
  enforce: 'post', // pre|default|post
  setup() {
    const pageTitle = useState<string>('currentPageTitle');

    watch(pageTitle, (title) => {
      useHead({
        title: title,
      });
    });

    return {
      provide: {
        pageTitle,
      },
    };
  },
});

interface PluginsInjections {
  $pageTitle: Ref<string>;
}

declare module '#app' {
  interface NuxtApp extends PluginsInjections {}
}
